import { useLocation } from 'react-router-dom';
import IncomingCallToast from './IncomingCallToast';
import { Toast as AnvilToast } from '@servicetitan/design-system';
import useToasts from '@modules/ToastModule/useToasts';

/**
 * Responsible for reading the incomingCallToasts from the ToastModule. Only renders if the user is not on the inbox page.
 */
const IncomingCallToastsGroup = () => {
  const { incomingCallToasts } = useToasts();
  const location = useLocation();
  const isInboxPage = location.pathname === '/';

  return (
    <AnvilToast.Group>
      {!isInboxPage &&
        incomingCallToasts.map((callToast) => (
          <IncomingCallToast key={callToast.id} {...callToast} />
        ))}
    </AnvilToast.Group>
  );
};

export default IncomingCallToastsGroup;
